import { HttpClient } from "../HttpClient";
/**
 * * Put Deductions
 */
export const PutDeductions = async (deductionData) => {
	try {
		const { data } = await HttpClient.put("api/assetRevenueDeductions", { ...deductionData });
		return await Promise.resolve(data);
	} catch (err) {
		return Promise.reject(err);
	}
};
